import { defaultSearch, makeLabel } from "../elements/select/migration.js";
import { infoCircleIcon } from "../elements/icons/index.js";
import { select } from "../elements/index.js";

/**
 * Todo: Add JSDoc comment
 */
export function makeDropdown({
	title,
	dataTestName = "wizard-step-dropdown",
	helpText,
	onChange,
	noDefaultSelection,
	noSelectionText,
	...spec
}) {
	return (html) =>
		html.div(
			{
				class: "wizard-step-dropdown",
				"data-test": dataTestName,
			},
			title ? titleRenderer(title) : () => {},
			select({
				searchable: defaultSearch({ items: spec.items }),
				allowEmptySelection: noDefaultSelection,
				emptyLabel: noSelectionText,
				onChange,
				items: spec.items.map((model) => ({
					label: makeLabel(model),
					value: model,
					selected: model.selected,
					match: model.match?.bind(model),
				})),
			}),
			helpIconRenderer({ helpText }),
		);
}

/**
 * Todo: Add JSDoc comment
 */
export function helpIconRenderer({ helpText }) {
	return infoCircleIcon({
		class: "help-button",
		title: helpText,
	});
}

/**
 * Todo: Add JSDoc comment
 */
export function titleRenderer(title) {
	return (html) => html.div({ class: "title" }, title);
}
